<template>
    <topBanner/>
    <marinesurvey/>
</template>

<script>
import topBanner from '../components/common/topBanner.vue'
import marinesurvey from '../components/marinesurvey.vue'
export default {
    components: {
        topBanner,
        marinesurvey
    },
    data(){
        return{}
    }
}
</script>